// extracted by mini-css-extract-plugin
module.exports = {"disbursement_choose":"main_clients_application_disbursement_shared--disbursement_choose","cancel":"main_clients_application_disbursement_shared--cancel"};